import { IUser } from "../constants/types";
import { BASE_URL, get } from "./Common";

interface ProviderInfo {
  provider: string;
  providerId: string | number;
}

export interface UserInfoResponse {
  uid: string;
  firstName: string;
  lastName: string;
  email: string;
  sex: string;
  uniqueId: string;
  leaseTrackingId: string;
  registered: boolean;
  renewal: boolean;
  claimedDate?: number[];
  createdDate?: number[];
  lastAccessDate: number[];
  l1Id: number;
  l2Id: number;
  l3Id: number;
  l4Id: number;
  roommates: [];
  providerInfo: ProviderInfo[];
  userLifestyleQuestionsWithAnswers: any;
  invitations: [];
}

export const LoadUserInfo = async (userId: string, authToken: string) => {
  const url = `${BASE_URL}/users/${userId}`;

  const response = await get<IUser>(url, authToken);

  const success = response.status === 200;
  if (success) {
    return { error: false, result: response.parsedBody };
  }
  return { error: true };
};
